var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconActive = function SvgIconActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 27"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3D65DE",
    d: "m10.535 14.5.678-.157c.01-.788-.062-1.577-.213-2.353-2.789.124-5.624-.323-8.357.197q.03 1.023.062 2.045c2.803.178 5.62.187 8.426.029"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D65DE",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m10.535 14.5.678-.157c.01-.788-.062-1.577-.213-2.353-2.789.124-5.624-.323-8.357.197q.03 1.023.062 2.045c2.803.178 5.62.187 8.426.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D65DE",
    d: "m21.679 14.5.678-.157a11.6 11.6 0 0 0-.213-2.353c-2.79.124-5.624-.323-8.358.197l.062 2.045c2.804.178 5.62.187 8.426.029"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D65DE",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m21.679 14.5.678-.157a11.6 11.6 0 0 0-.213-2.353c-2.79.124-5.624-.323-8.358.197l.062 2.045c2.804.178 5.62.187 8.426.029"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D65DE",
    d: "m20.446 25.071.553-.488c.008-2.451-.05-4.905-.173-7.32-2.278.386-4.594-1.006-6.826.612l.05 6.363c2.29.555 4.59.583 6.882.089"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D65DE",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m20.446 25.071.553-.488c.008-2.451-.05-4.905-.173-7.32-2.278.386-4.594-1.006-6.826.612l.05 6.363c2.29.555 4.59.583 6.882.089"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D65DE",
    d: "m10.446 25.071.553-.488c.008-2.451-.05-4.905-.174-7.32-2.277.386-4.593-1.006-6.825.612l.05 6.363c2.29.555 4.59.583 6.882.089"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3D65DE",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m10.446 25.071.553-.488c.008-2.451-.05-4.905-.174-7.32-2.277.386-4.593-1.006-6.825.612l.05 6.363c2.29.555 4.59.583 6.882.089M9.227 7.709c-.307-.126-.622-.27-.831-.532-.191-.239-.272-.551-.318-.857a4.58 4.58 0 0 1 .38-2.581c.082-.176.187-.36.362-.436.27-.12.575.057.81.241 1.715 1.346 2.834 3.46 3.002 5.67.042-1.394.227-2.8.735-4.095.509-1.294 1.362-2.475 2.533-3.186.7-.425 1.65-.651 2.29-.135.473.382.62 1.055.617 1.673-.007 1.505-.732 2.959-1.814 3.977-.899.847-2.411 1.84-3.692 1.661s-2.868-.903-4.071-1.398z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 22.74,
    height: 26.322,
    x: 1.117,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "1 1",
    numOctaves: 3,
    seed: 1341,
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    width: "100%",
    height: "100%",
    "in": "shape",
    result: "displacedImage",
    scale: 1,
    xChannelSelector: "R",
    yChannelSelector: "G"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_10259_8436"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "displacedImage"
  })), /*#__PURE__*/React.createElement("feTurbulence", {
    baseFrequency: "2 2",
    numOctaves: 3,
    result: "noise",
    seed: 1299,
    stitchTiles: "stitch",
    type: "fractalNoise"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "noise",
    result: "alphaNoise",
    type: "luminanceToAlpha"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", {
    "in": "alphaNoise",
    result: "coloredNoise1"
  }, /*#__PURE__*/React.createElement("feFuncA", {
    tableValues: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0",
    type: "discrete"
  })), /*#__PURE__*/React.createElement("feComposite", {
    "in": "coloredNoise1",
    in2: "effect1_texture_10259_8436",
    operator: "in",
    result: "noise1Clipped"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#FFF",
    result: "color1Flood"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "color1Flood",
    in2: "noise1Clipped",
    operator: "in",
    result: "color1"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_noise_10259_8436"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "effect1_texture_10259_8436"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "color1"
  }))))));
};
export default SvgIconActive;